<template>
  <div class="app-camera-view">
    <div
      ref="cameraView"
      class="camera-view"
    />
  </div>
</template>

<script>
export default {
  name: "AppCameraView",

  data() {
    return {
      live: false,
      loaded: false,
      stream: null,
      mediaDevices: null,
      peg: null,
      container: null,
      video: null,
      userMedia: true,
      params: {
        width: 0,
        height: 0,
        dest_width: 0, // size of captured image
        dest_height: 0, // these default to width/height
        image_format: "jpeg", // image format (may be jpeg or png)
        jpeg_quality: 90, // jpeg image quality from 0 (worst) to 100 (best)
        flip_horiz: true, // flip image horiz (mirror mode)
        fps: 30 // camera frames per second
      }
    };
  },

  mounted() {
    this.init();
    this.attach(this.$refs.cameraView);
  },

  methods: {
    init() {
      // Setup getUserMedia
      this.mediaDevices =
        navigator.mediaDevices && navigator.mediaDevices.getUserMedia
          ? navigator.mediaDevices
          : null;

      this.userMedia = this.userMedia && !!this.mediaDevices && !!window.URL;

      // Make sure media stream is closed when navigating away from page
      if (this.userMedia) {
        // window.addEventListener("beforeunload", function(event) {
        //   self.reset();
        // });
      }
    },

    attach(elem) {
      this.container = elem;
      elem.innerHTML = ""; // start with empty element

      // insert "peg" so we can insert our preview canvas adjacent to it later on
      var peg = document.createElement("div");
      elem.appendChild(peg);
      this.peg = peg;

      // set width/height if not already set
      if (!this.params.width) this.params.width = elem.offsetWidth;
      if (!this.params.height) this.params.height = elem.offsetHeight;

      // make sure we have a nonzero width and height at this point
      if (!this.params.width || !this.params.height) {
        // return this.dispatch(
        //   "error",
        //   new WebcamError(
        //     "No width and/or height for webcam.  Please call set() first, or attach to a visible element."
        //   )
        // );
      }

      // set defaults for dest_width / dest_height if not set
      if (!this.params.dest_width) this.params.dest_width = this.params.width;
      if (!this.params.dest_height)
        this.params.dest_height = this.params.height;

      // check for default fps
      if (typeof this.params.fps !== "number") this.params.fps = 30;

      // adjust scale if dest_width or dest_height is different
      var scaleX = this.params.width / this.params.dest_width;
      var scaleY = this.params.height / this.params.dest_height;

      if (this.userMedia) {
        // setup webcam video container
        var video = document.createElement("video");
        video.setAttribute("autoplay", "autoplay");
        video.setAttribute("playsinline", "playsinline");
        video.style.width = "" + this.params.dest_width + "px";
        video.style.height = "" + this.params.dest_height + "px";

        if (scaleX != 1.0 || scaleY != 1.0) {
          elem.style.overflow = "hidden";
          video.style.webkitTransformOrigin = "0px 0px";
          video.style.mozTransformOrigin = "0px 0px";
          video.style.msTransformOrigin = "0px 0px";
          video.style.oTransformOrigin = "0px 0px";
          video.style.transformOrigin = "0px 0px";
          video.style.webkitTransform =
            "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
          video.style.mozTransform =
            "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
          video.style.msTransform =
            "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
          video.style.oTransform =
            "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
          video.style.transform =
            "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }

        // add video element to dom
        elem.appendChild(video);
        this.video = video;

        // ask user for access to their camera
        var self = this;
        this.mediaDevices
          .getUserMedia({
            audio: false,
            video: this.params.constraints || {
              facingMode: { exact: "user" },
              mandatory: {
                minWidth: this.params.dest_width,
                minHeight: this.params.dest_height
              }
            }
          })
          .then(function(stream) {
            console.log(stream);
            // got access, attach stream to video
            video.onloadedmetadata = function() {
              this.stream = stream;
              self.loaded = true;
              self.live = true;
              // self.dispatch("load");
              // self.dispatch("live");
              self.flip();
            };
            // as window.URL.createObjectURL() is deprecated, adding a check so that it works in Safari.
            // older browsers may not have srcObject
            if ("srcObject" in video) {
              video.srcObject = stream;
            } else {
              // using URL.createObjectURL() as fallback for old browsers
              video.src = window.URL.createObjectURL(stream);
            }
          })
          .catch(function(err) {
            console.log(err);
            // JH 2016-07-31 Instead of dispatching error, now falling back to Flash if userMedia fails (thx @john2014)
            // JH 2016-08-07 But only if flash is actually installed -- if not, dispatch error here and now.
            if (self.params.enable_flash && self.detectFlash()) {
              setTimeout(function() {
                self.params.force_flash = 1;
                self.attach(elem);
              }, 1);
            } else {
              // self.dispatch("error", err);
            }
          });
      } else {
        // this.dispatch("error", new WebcamError(this.params.noInterfaceFoundText));
      }

      // setup final crop for live preview
      if (this.params.crop_width && this.params.crop_height) {
        var scaled_crop_width = Math.floor(this.params.crop_width * scaleX);
        var scaled_crop_height = Math.floor(this.params.crop_height * scaleY);

        elem.style.width = "" + scaled_crop_width + "px";
        elem.style.height = "" + scaled_crop_height + "px";
        elem.style.overflow = "hidden";

        elem.scrollLeft = Math.floor(
          this.params.width / 2 - scaled_crop_width / 2
        );
        elem.scrollTop = Math.floor(
          this.params.height / 2 - scaled_crop_height / 2
        );
      } else {
        // no crop, set size to desired
        elem.style.width = "" + this.params.width + "px";
        elem.style.height = "" + this.params.height + "px";
      }
    },

    flip() {
      // flip container horiz (mirror mode) if desired
      if (this.params.flip_horiz) {
        var sty = this.container.style;
        sty.webkitTransform = "scaleX(-1)";
        sty.mozTransform = "scaleX(-1)";
        sty.msTransform = "scaleX(-1)";
        sty.oTransform = "scaleX(-1)";
        sty.transform = "scaleX(-1)";
        sty.filter = "FlipH";
        sty.msFilter = "FlipH";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.camera-view {
  width: 700px;
  height: 700px;
  border: 1px solid #000;
}
</style>
